import store from '@/store';
import { request } from '@/utils/request'

/**
 * 获取用户信息
 * @returns 
 */
export const getCurrent = async()=>{
  const loginInfo = (store.state as any).user.loginInfo
  const re:any = await request.get('/web/common/sysman/user/currentInfo')
  if(re.ok){
    let current = re.data || {};
    if (!current.roleTypeCode) {
      current.roleTypeCode = loginInfo.userType
    }
    if (!current.staffId) {
      current.staffId = current.roleTypeBizId
    }
    // if (current.roleTypeCode !== 'ADMIN' && (store.state as any).user.identityList?.length === 2) {
    //   current.modelType = 'ALL'
    // }
    const party = (store.state as any).user.identityList.find((item:any) => {
      return item.roleTypeCode === 'PARTYMEMBER'
    }) 
    if (party) {
      current.partyMemberId = party.roleTypeBizId
    }
    if(current.firmId){
      const res:any = await request.get(`/web/common/school-pr/info/${current.firmId}/${current.staffId}`)
      if(res.ok && res.data){
        current.faceId = res.data.faceId
        current.sex = res.data.sex
      }
    }
    store.commit('SET_CURRENT', current)
  }else{
    let loginInfo = (store.state as any).user.loginInfo
    store.commit('SET_CURRENT', {
      ...loginInfo,
      roleTypeCode: loginInfo.userType,
      name: loginInfo.userName,
      id: loginInfo.userId
    })
    
  }
}


/**
 * 获取Url中参数的值
 * @param {Stirng} name 参数的字段名
 */
 export function getUrlParam(name:string) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var result = window.location.search.substr(1).match(reg);
    if (result != null) return decodeURIComponent(result[2]);
    return null;
  }